import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WalletGiftcardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wallet_giftcard"}/>
}
